var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { createReducer } from '@reduxjs/toolkit';
var initialState = null;
export default createReducer(initialState, {
    'user/loadUserData/fulfilled': function (state, action) {
        return action.payload;
    },
    'user/updateName/fulfilled': function (state, action) {
        state.firstName = action.payload.firstName;
        state.lastName = action.payload.lastName;
    },
    'user/acceptInvite/fulfilled': function (state, action) {
        var workspaceId = action.payload;
        delete state.pendingInvites[workspaceId];
        state.workspaces = __spreadArray(__spreadArray([], ((state === null || state === void 0 ? void 0 : state.workspaces) || []), true), [workspaceId], false);
    },
    'user/rejectInvite/fulfilled': function (state, action) {
        var workspaceId = action.payload;
        var _a = __assign({}, state.pendingInvites), _b = workspaceId, omit = _a[_b], invites = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
        state.pendingInvites = invites;
    },
    'user/dismissMessage/pending': function (state, action) {
        var _a;
        var messageID = action.meta.arg;
        state.showMessage = __assign(__assign({}, (state.showMessage || {})), (_a = {}, _a[messageID] = true, _a));
    },
    'workspace/create/fulfilled': function (state, action) {
        state.workspaces = (state === null || state === void 0 ? void 0 : state.workspaces) || [];
        state.workspaces.push(action.payload.id);
    },
    'auth/signOut': function () { return initialState; },
});
